import {css} from "styled-components";
import {sizes} from "./sizes";

export const fontSize = px => css`
  font-size: ${px}px;
  @media only screen and ${sizes.max991} {
    font-size: ${(0.2 * px)}vw;
  }
`;
